import { Link } from "react-router-dom";
import { faqsAlert } from "../constants/constants";
import QuestionsAnswers from "./QuestionAnswers";
export default function FAQS() {
  return (
    <div>
      <div className="flex flex-col m-auto w-[95%] md:flex-row gap-7">
        {/* Left Section */}
        <div className="w-full md:w-1/3 flex flex-col items-center md:items-start text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl md:text-4xl text-[#01a4e4] pb-4 sm:pb-5 md:pb-6 px-4 font-bold">
            Please Contact us for a Demonstration
          </h2>
          <p className="pb-4 sm:pb-5 md:pb-6 text-[#3b4455] text-lg sm:text-xl md:text-2xl px-4 font-light">
            We currently provide technical support via support tickets to our
            customers. General and/or Legal Inquiries will normally be responded
            through our
            <Link className="text-blue-600" to='/contact-us'> Webform </Link>
            within 24-48 hours.
          </p>
          <p className="text-[#868e96] text-base sm:text-lg md:text-xl md:p-0 pl-5">
            Here are answers to some of the most common questions we get about
            the Messaging Platform.
          </p>
        </div>

        {/* Right Section (FAQs) */}
        <div className="flex-1">
          <QuestionsAnswers faqs={faqsAlert} />
        </div>
      </div>

    </div>
  );
}
